/** Reads only the stable same-origin platform contract; callers never configure an API origin. */
import { healthResponseSchema, type HealthResponse } from "@loomua/contracts";

export async function getHealth(): Promise<HealthResponse> {
  const response = await fetch("/api/health", {
    headers: { Accept: "application/json" }
  });

  if (!response.ok) {
    throw new Error(`Health request failed with status ${response.status}`);
  }

  return healthResponseSchema.parse(await response.json());
}
